import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditDesignationsReady} from '../redux/designations'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

// import * as Helpers from '../../../common/helpers'

// import {DesignationsType} from './DropDowns/index'

class AddEditDesignations extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        designationsName: "",


        designationsNameErrorText: false,
        designationsNameErrorData: '',

        subTitle: Constants.ADD_DESIGNATION

    }

    this.isComponentStillMounted = true

    this.designationsNameComponent = null
    this.designationsNameSection = null

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditDesignationsReady(false))

    if (this.props.designations && this.props.designations.designationsSelectedId && this.props.designations.designationsSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_DESIGNATION))
        this.setState({
            subTitle: "Edit Designation",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_DESIGNATION))
        this.setState({
            subTitle: "Add Designation"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.designations && this.props.designations.designationsSelectedId && this.props.designations.designationsSelectedId !== null) {
        this.getDesignationsById(this.props.designations.designationsSelectedId)
    }else{

    this.props.dispatch(addEditDesignationsReady(true))
    }
}

componentDidMount() {

        this.designationsNameSection = ReactDOM.findDOMNode(this.refs.designationsNameSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditDesignationsReady(false))
    let data = {}

    let designationsNameObject = this.mandateValidation("designationsName", Constants.FORM_INPUT)
    if (designationsNameObject.status) {
        data.name = this.designationsNameComponent.value
    } else {

         this.props.dispatch(addEditDesignationsReady(true))
        return
    }


    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editDesignations(apiPayloadData,this.state.designationsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditDesignationsReady(true))
                        this.props.history.push("/dashboard/designations/list")
                    } else {

                        this.props.dispatch(addEditDesignationsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditDesignationsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addDesignations(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditDesignationsReady(true))
                        this.props.history.push("/dashboard/designations/list")
                    } else {

                        this.props.dispatch(addEditDesignationsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditDesignationsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getDesignationsById = (id) => {
    apiService.getDesignationsById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        designationsData: responseData.data ,
                        designationsName : responseData.data.name               
                    })

                    if (this.isComponentStillMounted) {
                        this.designationsNameComponent.value=responseData.data.name
                    }

                    this.props.dispatch(addEditDesignationsReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditDesignationsReady(true))
        })
}








    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.designationsNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Designation Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Designation Name" type="text" ref={el => this.designationsNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("designationsName")}} />
                                                        <span className="help-block"style={{display: this.state.designationsNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.designationsNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        designations: state.designations,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditDesignations))


// WEBPACK FOOTER //
// ./src/modules/Designations/Components/AddEditDesignations.js